import { MatchedRoute } from 'react-router-config';
import { useEffect } from 'react';
import { useDispatch } from '../actions/types';
import { Actions as PageActions } from '../actions/page';
import { useQueryParam, StringParam } from 'use-query-params';

export default function usePageNavStart(matchedRoute: MatchedRoute<object>) {
  // console.log('1. usePageNavStart: ', { matchedRoute });
  const dispatch = useDispatch();
  const [queryParam] = useQueryParam('query', StringParam);

  useEffect(() => {
    // console.log('2. usePageNavStart: ', JSON.stringify(matchedRoute, null, 2));
    if (matchedRoute.route.component?.displayName === 'ArticlePage') {
      // @ts-ignore
      const articleMatch = matchedRoute.match.params.articleId.match(/^\d+/);
      const articleId = articleMatch ? articleMatch[0] : '';
      dispatch(
        PageActions.pageNavStart({
          pageType: 'article',
          articleId,
          path: window.location.pathname,
        })
      );
      return;
    }

    if (matchedRoute.route.component?.displayName === 'CategoryPage') {
      // @ts-ignore
      const categoryMatch = matchedRoute.match.params.categoryId.match(/^\d+/);
      const categoryId = categoryMatch ? categoryMatch[0] : '';
      dispatch(
        PageActions.pageNavStart({
          pageType: 'category',
          categoryId,
          path: window.location.pathname,
        })
      );
      return;
    }

    if (matchedRoute.route.component?.displayName === 'HomePage') {
      dispatch(
        PageActions.pageNavStart({
          pageType: 'home',
          path: window.location.pathname,
        })
      );
      return;
    }

    if (matchedRoute.route.component?.displayName === 'Error404Page') {
      dispatch(
        PageActions.pageNavComplete({
          pageType: 'error404',
          path: window.location.pathname,
        })
      );
      return;
    }

    if (matchedRoute.route.component?.displayName === 'Error401Page') {
      dispatch(
        PageActions.pageNavComplete({
          pageType: 'error401',
          path: window.location.pathname,
        })
      );
      return;
    }

    if (
      // @ts-ignore
      matchedRoute.route.component.displayName === 'SearchPage' &&
      queryParam
    ) {
      dispatch(
        PageActions.pageNavStart({
          pageType: 'search',
          searchTerm: queryParam,
          path: window.location.pathname,
        })
      );
    }

    // We must be at an extra route.
    if (matchedRoute.route.component?.displayName !== 'SearchPage') {
      dispatch(
        PageActions.pageNavComplete({
          pageType: 'extra',
          path: window.location.pathname,
        })
      );
    }
    // I only want this effect to run when either of these change, thus the eslint-disable
  }, [matchedRoute.match.url, queryParam]); // eslint-disable-line
}
